var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Injectable } from '@angular/core';
import { EventName, Events } from '../utils/events';
import { DatasetProvider } from './dataset';
import { API } from './api';
import { LocalStorageProvider } from './local-storage';
import { BaseProvider } from './base';
import { BehaviorSubject } from 'rxjs';
var Project = /** @class */ (function () {
    function Project() {
        this.datasetIdentifiers = [];
    }
    return Project;
}());
export { Project };
var ProjectProvider = /** @class */ (function (_super) {
    __extends(ProjectProvider, _super);
    function ProjectProvider(datasetProvider, api, localStorageProvider, events) {
        var _this = _super.call(this) || this;
        _this.datasetProvider = datasetProvider;
        _this.api = api;
        _this.localStorageProvider = localStorageProvider;
        _this.events = events;
        _this.projectsSubscription = new BehaviorSubject([]);
        _this._projects = [];
        _this.events.subscribe(EventName.DatasetProviderDelete, function (dataset) {
            _this.processDatasetDeleteEvent(dataset);
        });
        return _this;
    }
    Object.defineProperty(ProjectProvider.prototype, "projects", {
        get: function () {
            return this._projects;
        },
        set: function (projects) {
            this.setProjects(projects);
        },
        enumerable: true,
        configurable: true
    });
    ProjectProvider.prototype.getProjectNamePrefix = function (projectName) {
        return projectName.toLowerCase().includes('project') ? '' : ' Project:';
    };
    ProjectProvider.prototype.processDatasetDeleteEvent = function (dataset) {
        return __awaiter(this, void 0, void 0, function () {
            var project;
            return __generator(this, function (_a) {
                try {
                    project = this.getProjectById(dataset.projectId);
                    if (project === undefined) {
                        return [2 /*return*/];
                    }
                    project.datasetIdentifiers = project.datasetIdentifiers.filter(function (datasetIdentifier) { return datasetIdentifier != dataset.id; });
                    project.exportable = this.isExportable(project);
                }
                catch (err) {
                    throw err;
                }
                return [2 /*return*/];
            });
        });
    };
    ProjectProvider.prototype.fetchProjects = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var response, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.ensureDependenciesLoaded([this.datasetProvider])];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.api.get('projects')];
                    case 2:
                        response = _a.sent();
                        this.projects = response.message.projects.map(function (obj) {
                            return _this.toProject(obj);
                        });
                        return [2 /*return*/, this.projects];
                    case 3:
                        err_1 = _a.sent();
                        throw err_1;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ProjectProvider.prototype.fetchProjectsDebounce = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, this.debounce('fetchProjects', function () { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, this.fetchProjects()];
                                case 1: return [2 /*return*/, _a.sent()];
                            }
                        });
                    }); }, 250)];
            });
        });
    };
    ProjectProvider.prototype.load = function (force) {
        if (force === void 0) { force = false; }
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.ensureLoaded(function () { return _this.fetchProjectsDebounce(); }, force)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ProjectProvider.prototype.deactivateProject = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var index, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.delete("projects/" + id)];
                    case 1:
                        _a.sent();
                        index = this.projects.findIndex(function (project) { return project.id === id; });
                        if (this.projects.length > 1) {
                            this.projects.splice(index, 1);
                            // Must call setProjects specifically due to setters not being called on arrays in angular.
                            this.setProjects(this.projects);
                        }
                        else {
                            this.projects = [];
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        err_2 = _a.sent();
                        throw err_2;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Determine if a project has polygons based on whether any child datasets have polygons
     */
    ProjectProvider.prototype.hasPolygons = function (project) {
        for (var _i = 0, _a = project.datasetIdentifiers; _i < _a.length; _i++) {
            var datasetIdentifier = _a[_i];
            var dataset = this.datasetProvider.getDatasetById(datasetIdentifier);
            if (dataset !== undefined && dataset.hasPolygons()) {
                return true;
            }
        }
        return false;
    };
    /**
     * Stores the active image for this project/dataset so we can reload it later
     */
    ProjectProvider.prototype.storeActiveImageIdentifier = function (imageIdentifier) {
        return __awaiter(this, void 0, void 0, function () {
            var err_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.localStorageProvider.set("activeAsset", imageIdentifier)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        err_3 = _a.sent();
                        throw err_3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Load the active image for the current project/dataset if they exist
     */
    ProjectProvider.prototype.loadStoredActiveImageIdentifier = function () {
        return __awaiter(this, void 0, void 0, function () {
            var err_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.localStorageProvider.get("activeAsset")];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        err_4 = _a.sent();
                        throw err_4;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Remove the stored active image if there is one
     */
    ProjectProvider.prototype.removeStoredActiveImageIdentifier = function () {
        return __awaiter(this, void 0, void 0, function () {
            var err_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.localStorageProvider.remove("activeAsset")];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        err_5 = _a.sent();
                        throw err_5;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Find a project from an id
     */
    ProjectProvider.prototype.getProjectById = function (id) {
        return this.projects.find(function (project) { return project.id === id; });
    };
    ProjectProvider.prototype.getCount = function () {
        return this.projects.length;
    };
    ProjectProvider.prototype.getProjects = function (limit) {
        if (limit === void 0) { limit = this.projects.length; }
        return this.projects.slice(0, limit);
    };
    /**
     * Reload a project from BrainBank and replace the details of the local project object
     */
    ProjectProvider.prototype.reloadProject = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var response, project, location_1, err_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.get("projects/" + id)];
                    case 1:
                        response = _a.sent();
                        project = this.toProject(response.message);
                        location_1 = this.projects.findIndex(function (project) { return project.id === id; });
                        if (Number.isInteger(location_1)) {
                            this.projects[location_1] = project;
                        }
                        return [2 /*return*/, project];
                    case 2:
                        err_6 = _a.sent();
                        throw err_6;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * A common method to convert a BrainBank response object to a local Project object
     */
    ProjectProvider.prototype.toProject = function (obj) {
        var project = new Project();
        project.id = obj.projectIdentifier;
        project.name = obj.name;
        project.previewImageUrls = obj.previewImageUrls || [];
        project.datasetIdentifiers = obj.datasetIdentifiers || [];
        project.dateAdded = obj.dateAdded;
        project.numPromotedBrains = obj.promotedBrainCount;
        project.exportable = this.isExportable(project);
        return project;
    };
    /**
     * Create a new project
     */
    ProjectProvider.prototype.createProject = function (name) {
        return __awaiter(this, void 0, void 0, function () {
            var response, project, err_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.post('projects', { name: name })];
                    case 1:
                        response = _a.sent();
                        project = new Project();
                        project.id = response.message;
                        project.name = name;
                        project.previewImageUrls = [];
                        project.dateAdded = new Date().toString();
                        project.exportable = this.isExportable(project);
                        this.projects.push(project);
                        // Setter is not called on mutations (e.g.: push), thus we need
                        // to explicitly set, so that BehaviorSubject changes.
                        this.setProjects(this.projects);
                        return [2 /*return*/, project];
                    case 2:
                        err_7 = _a.sent();
                        throw err_7;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Rename a project
     * @param newName
     * @param projectIdentifier
     */
    ProjectProvider.prototype.renameProject = function (newName, projectIdentifier) {
        return __awaiter(this, void 0, void 0, function () {
            var e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.post("projects/" + projectIdentifier + "/rename", {
                                name: newName
                            })];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        throw e_1;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ProjectProvider.prototype.resetInfo = function () {
        this.projects = [];
        _super.prototype.resetInfo.call(this);
    };
    ProjectProvider.prototype.isExportable = function (project) {
        for (var _i = 0, _a = project.datasetIdentifiers; _i < _a.length; _i++) {
            var datasetIdentifier = _a[_i];
            var dataset = this.datasetProvider.getDatasetById(datasetIdentifier);
            if (dataset && (dataset.isSegmentation() || dataset.isObjectDetection())) {
                return true;
            }
        }
        return false;
    };
    ProjectProvider.prototype.setProjects = function (projects) {
        if (projects === void 0) { projects = []; }
        this._projects = projects;
        this.projectsSubscription.next(this._projects);
    };
    ProjectProvider = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [DatasetProvider,
            API,
            LocalStorageProvider,
            Events])
    ], ProjectProvider);
    return ProjectProvider;
}(BaseProvider));
export { ProjectProvider };
//# sourceMappingURL=project.js.map


// WEBPACK FOOTER //
// ./src/providers/project.ts.pre-build-optimizer.js